import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AppState } from '../../../context/stores/rootReducers';
import { useEffect } from 'react';
import { actions } from '../../../context/stores/rootActions';
import { eBaseActionStatus } from '../../../context/base/eBaseActionStatus';

export function useLookupKeywordSeo() {
	const dispatch = useDispatch();
	const { status, allKeywordSeo } = useSelector((state: AppState) => state.keywordSeo);
	useEffect(() => {
		if (status === eBaseActionStatus.idle || status === eBaseActionStatus.reload) dispatch(actions.keywordSeo.getAllRequest());
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return { keyword_seo_all: allKeywordSeo };
}
